module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE FAR REACHES")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "part1"
    }
  }), _vm._v("PART I")]), _vm._v(" "), _c('p', {
    staticClass: "part"
  }, [_vm._v("Tarawa")]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_c('em', [_vm._v("Watchman, tell us of the night,"), _c('br'), _vm._v("What its signs of promise are."), _c('br'), _vm._v("Traveler, over yon mountain’s height,"), _c('br'), _vm._v("See that glory-beaming star!")])]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_c('em', [_vm._v("Watchman, does its beauteous ray"), _c('br'), _vm._v("Aught of joy or hope foretell?"), _c('br'), _vm._v("Traveler, yes; it brings the day,"), _c('br'), _vm._v("Promised day of Israel.")])]), _vm._v(" "), _c('p', {
    staticClass: "centerc"
  }, [_vm._v("—J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWRING, A HYMN")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726f9926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 72
// module chunks = 0